// extracted by css-extract-rspack-plugin
export default {"container":"RadioButton-module__container","selected":"RadioButton-module__selected"};